import { Modal } from '@material-ui/core';
import { FC, useEffect, useState } from "react";
import DevicesModalTitle from "./devices-modal-title";
import DevicesTypeItem from "./components/device-type-item";
import DevicesBoxList from "./components/devices-box-list";
import { getMediaDevices } from "../Selector/utils";
import SelectedDevicesItem from "./components/selected-devices-item";
import { useTranslation } from "react-i18next";

export interface devicesTypes{
    icon: string
    label: string
    type: "audio" | "video"
}

type DevicesModalProps = {
    openModalDevices: boolean
    setOpenModalDevices: (value: boolean) => void
    selectedMediaDevices: MediaDeviceInfo[]
    onAddMediaDevice: (data: MediaDeviceInfo) => void
    onRemoveMediaDevice: (data: MediaDeviceInfo) => void
}

const DevicesModal: FC<DevicesModalProps> = (props) => {
    const { t } = useTranslation(["videocall"]);
    const { openModalDevices, setOpenModalDevices, selectedMediaDevices, onAddMediaDevice, onRemoveMediaDevice } = props
    // const [openModalDevices, setOpenModalDevices] = useState(false)
    const [mediaDevices, setMediaDevices] = useState<MediaDeviceInfo[]>([])
    const [devicesType, setDevicesType] = useState<devicesTypes[]>([
        {icon: "fas fa-waveform", label: "Audio", type: "audio"},
        {icon: "fas fa-camera-web", label: "Vídeo", type: "video"}
    ])
    const [typeSelected, setTypeSelected] = useState<"audio" | "video">("audio")

    //Used to load audio/video media devices
    useEffect(() => {
        getMediaDevices(typeSelected)
            .then(devices => setMediaDevices(devices))
            .catch(error => {
                console.error("Could not get media devices", error);
                setMediaDevices([])
            })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeSelected, openModalDevices]);

    return(
        <Modal open={openModalDevices} onClose={() => setOpenModalDevices(false)} >
            <div className="modal-primary devices-modal">
          
                    <DevicesModalTitle 
                        label={t("modal.devices.add")}
                        onClose={() => setOpenModalDevices(false)} />
                    <div className="PanelLayout">
                        <div className="SideBarMenu">
                            {devicesType.length > 0 &&
                                devicesType.map(eachDeviceType => (
                                    <DevicesTypeItem data={eachDeviceType} selectOption={(value: "audio" | "video") => setTypeSelected(value)} />
                                ))
                            }
                        </div>
                        <div className="DevicesList">
                            {selectedMediaDevices.length > 0 &&
                                // eslint-disable-next-line react/jsx-no-useless-fragment
                                <>
                                    <div className="CurentDevices">
                                        <p>{t("modal.devices.addedDevices").toUpperCase()}</p>
                                        {selectedMediaDevices.map(eachDevice => (
                                        <div className="SelectedMediaDevices__Table" key={eachDevice.deviceId}>
                                            <SelectedDevicesItem 
                                                mediaDevice={eachDevice} 
                                                removeDevice={onRemoveMediaDevice} />
                                        </div>
                                        ))}
                                    </div>
                                </>
                            }
                            {mediaDevices.length > 0 &&
                                <DevicesBoxList 
                                    addNewDevice={onAddMediaDevice} 
                                    availableDevices={mediaDevices} 
                                    addedDevices={selectedMediaDevices}
                                    onRemoveMediaDevice={onRemoveMediaDevice}
                                />   
                            }
                        </div>
                    </div>
                
            </div>
        </Modal>
    )
}

export default DevicesModal
